import taskListUtils from "@/js/workspace/task_list_util.js";
const filters = {
    //过滤树，id规则： 0:根节点 1-99:树节点 >99:叶节点
    originalTree: [
        {id:1,name:"typeName",pid:0,sort:0},
        {id:2,name:"statusName",pid:0,sort:1},
        {id:3,name:"dateName",pid:0,sort:2},
        {id:100,name:"type.all",pid:1,sort:0},
        {id:101,name:"type.transfer",pid:1,sort:1},
        {id:102,name:"type.sync",pid:1,sort:2},
        {id:103,name:"type.backup",pid:1,sort:3},
        {id:104,name:"type.business",pid:1,sort:4},
        {id:105,name:"type.remoteUpload",pid:1,sort:5},
        {id:106,name:"type.emailMigration",pid:1,sort:6},
        {id:200,name:"status.all",pid:2,sort:0},
        {id:201,name:"status.preset",pid:2,sort:1},
        {id:202,name:"status.running",pid:2,sort:2},
        {id:203,name:"status.success",pid:2,sort:3},
        {id:204,name:"status.patial",pid:2,sort:4},
        {id:205,name:"status.failed",pid:2,sort:5},
        {id:206,name:"status.canceled",pid:2,sort:6},
        {id:300,name:"date.all",pid:3,sort:0},
        {id:301,name:"date.today",pid:3,sort:1},
        {id:302,name:"date.latestWeek",pid:3,sort:2},
        {id:303,name:"date.latestMonth",pid:3,sort:3},
        {id:304,name:"date.customDate",pid:3,sort:4},
    ],
    tree: [],
    init(root) {
        const list = this.originalTree;
        var map = {};
        //1. 以pid整理list
        list.forEach((item) => {
            if (map[item.pid]) {
                map[item.pid].push(item);
            } else {
                map[item.pid] = [item];
            }
        });
        //2. 利用第一步得到的对象对原数组list进行修改
        list.forEach((item) => {
            if (map[item.pid]) {
                item.children = map[item.id];
            }
        });
        // 3.过滤
        map = list.filter((item) => {
            return item.pid == root;
        });
        this.tree = map;
        return map;
    },
    //根据传入的规则数组进行过滤: list:原始数组,arr:规则数组,param:参数对象
    filterByArr(list,arr,param) {
        var resList = list;
        for (let i = 0; i < arr.length; i++) {
            //获取ruleId
            const ruleId = arr[i];
            if(ruleId){
                resList = this.filter(resList,ruleId,param)
            }
        }
        return resList;
    },
    //根据传入的规则进行过滤: list:数据数组,ruleId:规则id,param:参数对象
    filter(list,ruleId,param) {
        if(!(list&&list.length>0)) {
            return list;
        }
        //获取规则根节点
        const ruleRoot = parseInt((ruleId % 1000) / 100);
        var that = this;
        switch (ruleRoot) {
            case 1:
                list = that.filterForType(list,ruleId);
                break;
            case 2:
                list = that.filterForStatus(list,ruleId);
                break;
            case 3:
                list = that.filterForDate(list,ruleId,param);
                break;
            default:
                break;
        }
        return list;
    },
    //规则实现: list:数据数组,rule:规则,param:参数对象,index:当前层级
    //类型筛选
    filterForType(list,rule) {
        if(rule != 100) {
            list = list.filter(function (item) {
                return item.lowerType == rule;
            });
        }
        return list;
    },
    //状态筛选
    filterForStatus(list,rule) {
        console.log(rule)
        switch (rule) {
            case 200:
                //所有状态
                list = list;
                break;
            case 201:
                //预设
                list = list.filter(function (item) {
                    return !item.schedules.disabled;
                });
                break;
            case 202:
                //运行
                list = list.filter(function (item) {
                    // if (item.type == 1&&item.branchType!='cloudEmailTransfer') {
                    //     return taskListUtils.showTransferRunning(item);
                    // }else if (item.type == 6) {
                    //     return taskListUtils.showBackupRunning(item);
                    // } else {
                    //     if (item.sources) {
                    //         return taskListUtils.showSyncSourceRunning(item);
                    //     } else {
                    //         return taskListUtils.showSyncSingleRunning(item);
                    //     }
                    // }
                    return item.status == 1 || item.status == 2;
                });
                break;
            case 203:
                //成功
                list = list.filter(function (item) {
                    // if(item.branchType == 'realtime'){
                    //     return;
                    // }
                    // if (!item.sources) {
                    //     return taskListUtils.showSuccessStatus(item);
                    // } else {
                    //     return taskListUtils.showSourceSuccessStatus(item);
                    // }
                    return (item.status == 0 && item.result == 1);
                });
                break;
            case 204:
                //部分成功
                list = list.filter(function (item) {
                    // if(item.branchType == 'realtime'){
                    //     return;
                    // }
                    // if (!item.sources) {
                    //     return taskListUtils.showpartialStatus(item);
                    // } else {
                    //     return taskListUtils.showSourcepartialStatus(item);
                    // }
                    return (item.status == 0 && item.result == 2);
                });
                break;
            case 205:
                //失败
                list = list.filter(function (item) {
                    // if(item.branchType =='realtime'){
                    //     return;
                    // }
                    // if (!item.sources) {
                    //     if(item.type==6 && item.result == 'error'){
                    //         return true;
                    //     }
                    //     return item.result == 'error' && ((item.errorFileCount / item.totalFileCount) * 100 > 20);
                    // } else {
                    //     //如果是多源或多目标同步失败
                    //     return taskListUtils.showSwitchSourcesFailureStatus(item);
                    // }
                    return (item.status == 0 && item.result == -1);
                });
                break;
            case 206:
                //取消
                list = list.filter(function (item) {
                    // if(item.branchType == 'realtime'){
                    //     return;
                    // }
                    // return (taskListUtils.showCancelStatus(item) || item.cancelStatus);
                    return (item.status == 0 && item.result == 0);
                });
                break;
            default:
                break;
        }
        return list;
    },
    //日期筛选
    filterForDate(list,rule,param) {
        var that = this;
        switch (rule) {
            case 300:
                //所有日期
                list = list;
                break;
            case 301:
                //今天
                list = list.filter(function (item) {
                    return that.conversionTime(item.createTime) == that.conversionTime(new Date());
                });
                break;
            case 302:
                //最近一周
                list = list.filter(function (item) {
                    let lastestWeek = that.conversionTime(new Date() - 7 * 24 * 3600 * 1000);
                    return item.createTime >= that.conversionLongTime(lastestWeek);
                });
                break;
            case 303:
                //最近一月
                list = list.filter(function (item) {
                    let latestMonth = that.conversionTime(new Date().setMonth(new Date().getMonth() - 1));
                    return item.createTime >= that.conversionLongTime(latestMonth);
                });
                break;
            case 304:
                //自定义区间
                console.log(param)
                if(param.date.min&&param.date.max) {
                    list = list.filter(function (item) {
                        console.log(item.createTime)
                        return item.createTime >= param.date.min && item.createTime < param.date.max;
                    });
                }
                break;
            default:
                break;
        }
        return list;
    },
    //把时间转换为long类型
    conversionLongTime (time) {
        var date = new Date(time);
        let res = date.getTime();
        return res;
    },
    //转换时间格式
    conversionTime (time) {
        var date = new Date(time);
        let year = date.getFullYear();
        let Month = date.getMonth() + 1;
        let day = date.getDate();
        let res = year + '-' + Month + '-' + day;
        return res;
    },
}

export default filters


// WEBPACK FOOTER //
// ./src/js/workspace/task_list_filters.js